import { FC, useContext, useEffect } from 'react';

import { useVideoContext } from '../../VideoController/VideoController.context';

import Code from '../../../Shared/Code';
import ContentGenerator from '../../../Shared/ContentGenerator';

import { hydrateContent } from '../../../../utils/hydrate';

import { Content } from '../../../../types/tour';
import { State } from '../../../../types/video';

const codeSample = (state: State) => `
const [client] = useState<StreamVideoClient>(() => {
  const user = {
    id: "${state.userId}",
    name: "${state.userName}",
    image:
      "https://getstream.io/random_svg/?id=${state.userId}&name=${state.userName}",
  };
  const token =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiQ2FkZV9Ta3l3YWxrZXIiLCJpc3MiOiJwcm9udG8iLCJzdWIiOiJ1c2VyL0NhZGVfU2t5d2Fsa2VyIiwiaWF0IjoxNjg5MjY2MjQxLCJleHAiOjE2ODk4NzEwNDZ9.xMZKhSOeYybtXlpalHdrwiJCEd2wxhY6UtHU4PfJxmk";
  return new StreamVideoClient({
    apiKey: "mmhfdzb5evj2",
    user,
    token,
    options: { logLevel: "warn" },
  });
});
`;

export type Props = {
  content: Content;
  setComplete: () => void;
  goNext: () => void;
};

export const Step2: FC<Props> = ({ setComplete, content }) => {
  const { state, setClient } = useVideoContext();

  const run = async () => {
    await setClient();
    setComplete();
  };

  return (
    <ContentGenerator
      content={hydrateContent(state?.userName || '', content)}
      icon={content?.icon}
      code={
        state?.apiKey && (
          <Code
            language="jsx"
            footer={{ label: 'Run Code', run, disabled: !!state.client }}
            wrapLongLines={true}
          >
            {codeSample(state)}
          </Code>
        )
      }
    />
  );
};
